import { useState } from 'react';
import { api, ApiError } from '../api/client';
import { Bandeau, Champ, Modale } from './ui';
import { T } from '../i18n';

/**
 * Changer son propre mot de passe.
 *
 * Les trois comptes sont crees a l'installation avec un mot de passe tire au
 * hasard. Sans cet ecran, ce mot de passe resterait le leur pour toujours et
 * finirait sur un papier colle sous le clavier. Chacun doit pouvoir poser le
 * sien, sans passer par Hichem.
 */
export function MotDePasse({ onFermer }: { onFermer: () => void }) {
  const [actuel, setActuel] = useState('');
  const [nouveau, setNouveau] = useState('');
  const [confirme, setConfirme] = useState('');
  const [erreur, setErreur] = useState<string | null>(null);
  const [fait, setFait] = useState(false);
  const [envoi, setEnvoi] = useState(false);

  const tropCourt = nouveau.length > 0 && nouveau.length < 8;
  const different = confirme.length > 0 && nouveau !== confirme;
  const pret = actuel.length > 0 && nouveau.length >= 8 && nouveau === confirme;

  async function enregistrer() {
    setEnvoi(true); setErreur(null);
    try {
      await api.post('/auth/mot-de-passe', { actuel, nouveau });
      setFait(true);
    } catch (e) {
      setErreur(e instanceof ApiError ? e.erreur : T.motDePasse.erreur);
      setEnvoi(false);
    }
  }

  return (
    <Modale titre={T.motDePasse.titre} onFermer={onFermer}>
      {fait ? (
        <>
          <Bandeau type="ok" titre={T.motDePasse.fait}>
            {T.motDePasse.actif}
          </Bandeau>
          <div className="actions" style={{ marginTop: 14, justifyContent: 'flex-end' }}>
            <button className="btn btn-p" onClick={onFermer}>{T.motDePasse.fermer}</button>
          </div>
        </>
      ) : (
        <>
          {erreur && <div style={{ marginBottom: 12 }}><Bandeau type="ko">{erreur}</Bandeau></div>}
          <Champ label={T.motDePasse.actuel}>
            <input type="password" autoFocus autoComplete="current-password"
                   value={actuel} onChange={(e) => setActuel(e.target.value)} />
          </Champ>
          <div style={{ marginTop: 12 }}>
            <Champ label={T.motDePasse.nouveau} aide={T.motDePasse.minimum}>
              <input type="password" autoComplete="new-password"
                     value={nouveau} onChange={(e) => setNouveau(e.target.value)} />
            </Champ>
            {tropCourt && <p className="mini sourdine" style={{ marginTop: 6 }}>{T.motDePasse.encore(8 - nouveau.length)}</p>}
          </div>
          <div style={{ marginTop: 12 }}>
            <Champ label={T.motDePasse.repetez}>
              <input type="password" autoComplete="new-password"
                     value={confirme} onChange={(e) => setConfirme(e.target.value)} />
            </Champ>
            {different && <p className="mini sourdine" style={{ marginTop: 6 }}>{T.motDePasse.different}</p>}
          </div>
          <div className="actions" style={{ marginTop: 16, justifyContent: 'flex-end' }}>
            <button className="btn" onClick={onFermer}>{T.motDePasse.annuler}</button>
            <button className="btn btn-p" disabled={!pret || envoi} onClick={() => void enregistrer()}>
              {T.motDePasse.changer}

            </button>
          </div>
        </>
      )}
    </Modale>
  );
}
